import { render } from "./NotificationPerfectionAchievement.vue?vue&type=template&id=70486bda&scoped=true"
import script from "./NotificationPerfectionAchievement.vue?vue&type=script&lang=js"
export * from "./NotificationPerfectionAchievement.vue?vue&type=script&lang=js"

import "@/css/components/notification-perfection-achievement.css?vue&type=style&index=0&id=70486bda&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70486bda"]])

export default __exports__